import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const getUserSessions = createAsyncThunk(
  'user/getUserSessions',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      const response = await axios.get(
        `${ROOT_URL}/master-user/sessions`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      const data = error.response?.data;
      if (data && typeof data === 'object') {
        return rejectWithValue({
          ...data,
          status: data.status || error.response?.status,
        });
      }
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
      });
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  sessions: [],
  /** Avoid skeleton flash on refetch; empty `sessions` after first load is valid. */
  hasLoadedOnce: false,
};

const getUserSessionsSlice = createSlice({
  name: 'getUserSessions',
  initialState,
  reducers: {
    resetSessionsState: (state) => {
      state.loading = false;
      state.error = null;
      state.sessions = [];
      state.hasLoadedOnce = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserSessions.pending, (state) => {
        state.loading = !state.hasLoadedOnce;
        state.error = null;
      })
      .addCase(getUserSessions.fulfilled, (state, action) => {
        state.loading = false;
        state.hasLoadedOnce = true;
        state.sessions = action.payload.sessions;
      })
      .addCase(getUserSessions.rejected, (state, action) => {
        state.loading = false;
        state.hasLoadedOnce = false;
        state.error = action.payload;
      });
  },
});

export const { resetSessionsState } = getUserSessionsSlice.actions;
export default getUserSessionsSlice.reducer; 